/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BulkUpdateBrandsRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {BulkUpdateBrandsResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const bulkUpdateBrands = (request: BulkUpdateBrandsRequest, options?: CashRequestOptions) => post<BulkUpdateBrandsRequest, BulkUpdateBrandsResponse>("/2.0/cash/bulk-update-brands", request, {...options, rejectOnError: true })